(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["silxine-care-guide"] && !Shopify.designMode) return;
  try {
    
function initializeCareGuide(scope) {
  scope.querySelectorAll('[data-silxine-care-guide]').forEach(root => {
    if (root.dataset.careReady === 'true') return;
    root.dataset.careReady = 'true';
    const buttons = [...root.querySelectorAll('.sxcare-method-choice')];
    function selectMethod(button) {
      buttons.forEach(item => {
        const selected = item === button;
        item.setAttribute('aria-pressed', String(selected));
        const panel = root.querySelector('[id="' + item.getAttribute('aria-controls') + '"]');
        if (panel) panel.hidden = !selected;
      });
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => selectMethod(button));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus();
        selectMethod(buttons[next]);
      });
    });
  });
}
initializeCareGuide(document);
document.addEventListener('shopify:section:load', event => initializeCareGuide(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silxine-fabrics-editorial"] && !Shopify.designMode) return;
  try {
    

(() => {
  function mountFabrics(root) {
    if (root.dataset.fabricsReady) return;
    root.dataset.fabricsReady = 'true';
    const controller = new AbortController();
    const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal:controller.signal});
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = root.querySelectorAll('.sxfb-reveal');
    let observer;
    if (!reducedMotion && 'IntersectionObserver' in window) {
      root.classList.add('sxfb-motion-ready');
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('sxfb-is-visible'); observer.unobserve(entry.target); }
      }), {rootMargin:'0px 0px -8% 0px', threshold:0.08});
      reveals.forEach(el => observer.observe(el));
    } else reveals.forEach(el => el.classList.add('sxfb-is-visible'));
    const carousel = root.querySelector('[data-certification-carousel]');
    if (carousel) {
      const slides = [...carousel.querySelectorAll('.sxfb-certification-card')];
      const previous = root.querySelector('[data-certification-prev]');
      const next = root.querySelector('[data-certification-next]');
      const current = root.querySelector('[data-certification-current]');
      let index = 0, frame = 0;
      const render = value => { index = Math.max(0,Math.min(value,slides.length-1)); current.textContent = String(index+1).padStart(2,'0'); previous.disabled = index===0; next.disabled = index===slides.length-1; };
      const move = value => { const target = Math.max(0,Math.min(value,slides.length-1)); carousel.scrollTo({left:slides[target].offsetLeft-carousel.offsetLeft,behavior:reducedMotion?'auto':'smooth'}); render(target); };
      listen(previous,'click',()=>move(index-1));
      listen(next,'click',()=>move(index+1));
      listen(carousel,'scroll',()=> { cancelAnimationFrame(frame); frame=requestAnimationFrame(()=> {
        render(slides.reduce((best,slide,i)=>{const distance=Math.abs(slide.offsetLeft-carousel.offsetLeft-carousel.scrollLeft);return distance<best.distance?{i,distance}:best;},{i:0,distance:Infinity}).i);
      }); }, {passive:true});
      controller.signal.addEventListener('abort',()=>cancelAnimationFrame(frame),{once:true});
      render(0);
    }
    for (const selector of ['[data-grade-6a-toggle]','[data-momme-measurement-toggle]']) {
      const button = root.querySelector(selector);
      if (!button) continue;
      const panel = root.querySelector('#'+button.getAttribute('aria-controls'));
      const label = button.querySelector('[data-momme-measurement-label]');
      listen(button,'click',()=> {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded',String(expanded));
        panel.hidden = !expanded;
        if (label) label.textContent = expanded ? button.dataset.openLabel : button.dataset.closedLabel;
      });
    }
    listen(document,'shopify:section:unload',event=>{if(event.target.contains(root)){observer?.disconnect();controller.abort();}});
  }
  document.querySelectorAll('[data-silxine-fabrics]').forEach(mountFabrics);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-silxine-fabrics]').forEach(mountFabrics));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silxine-footer"] && !Shopify.designMode) return;
  try {
    
  const cookiePreferencesSelector = '[data-silxine-cookie-preferences]';
  const cookieBannerScriptSource = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';

  const loadCookieBanner = () => {
    if (window.privacyBanner?.showPreferences) {
      return Promise.resolve();
    }

    const existingScript = document.querySelector(`script[src="${cookieBannerScriptSource}"]`);

    if (existingScript) {
      return new Promise((resolve, reject) => {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = cookieBannerScriptSource;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest(cookiePreferencesSelector);

    if (!trigger) {
      return;
    }

    trigger.disabled = true;

    try {
      await loadCookieBanner();

      if (!window.privacyBanner?.showPreferences) {
        throw new Error('Shopify privacy preferences are unavailable.');
      }

      await window.privacyBanner.showPreferences();
    } catch (error) {
      console.error('Unable to open Shopify cookie preferences.', error);
    } finally {
      trigger.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silxine-mobile-menu-default"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silxine-mobile-menu-default')) {
    customElements.define('silxine-mobile-menu-default', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.observer = new MutationObserver((records) => {
          if (!window.matchMedia('(max-width: 1023px)').matches) return;

          for (const record of records) {
            const opener = record.target;

            if (!opener.matches('[data-mobile-toggle]')) continue;
            if (record.oldValue === 'true' || opener.getAttribute('aria-expanded') !== 'true') continue;

            const header = opener.closest('header-component');

            if (!this.isConnected || !header?.isConnected || !header.mobileOpen) continue;
            if (typeof header.toggleMobileSubmenu !== 'function') continue;

            const toggle = Array.from(header.querySelectorAll(
              '.mobile-drawer__menu > .mobile-drawer__item > [data-mobile-submenu-toggle]'
            )).find((item) => {
              const label = item.querySelector(
                '.mobile-drawer__toggle-label, .mobile-drawer__toggle-link'
              );

              return label?.textContent.trim().toLowerCase() === 'sleepwear';
            });

            const id = toggle?.dataset.mobileSubmenuToggle;

            if (id && header.openMobileSubmenus instanceof Set && !header.openMobileSubmenus.has(id)) {
              header.toggleMobileSubmenu(id);
            }
          }
        });

        this.observer.observe(document.documentElement, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-expanded'],
          attributeOldValue: true
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silxine-story-editorial"] && !Shopify.designMode) return;
  try {
    

(() => {
  function mountStory(root) {
    if (root.dataset.storyReady) return;
    root.dataset.storyReady = 'true';
    const controller = new AbortController();
    const listen = (target, type, handler) => target.addEventListener(type, handler, {signal: controller.signal});
    const entries = Array.from(root.querySelectorAll('.sxst-chapter-entry'));
    const index = root.querySelector('.sxst-story-directory');
    let printing = false, printState = [];
    function sync() {
      entries.forEach(entry => {
        entry.querySelector('summary').setAttribute('aria-expanded', String(entry.open));
        const label = entry.querySelector('.sxst-chapter-action-label');
        label.textContent = entry.open ? label.dataset.openLabel : label.dataset.closedLabel;
      });
    }
    function offset() {
      const header = document.querySelector('.shopify-section-group-header-group.sticky');
      return header ? header.getBoundingClientRect().height : 0;
    }
    function positionAt(target, focusTarget) {
      requestAnimationFrame(() => {
        if (!root.isConnected) return;
        const top = offset();
        root.style.setProperty('--sxst-header-offset', top + 'px');
        if (focusTarget) focusTarget.focus({preventScroll:true});
        window.scrollTo({top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - top - 16), behavior:'instant'});
      });
    }
    function setEntry(entry) { entries.forEach(item => { item.open = item === entry; }); sync(); }
    function record(target) { if (location.hash !== '#' + target.id) history.pushState(null, '', location.pathname + location.search + '#' + target.id); }
    function open(entry, update = true) { setEntry(entry); if (update) record(entry); positionAt(entry, entry.querySelector('summary')); }
    function showIndex() { setEntry(null); record(index); positionAt(index, index.querySelector('h2')); }
    entries.forEach(entry => {
      listen(entry.querySelector('summary'), 'click', event => { event.preventDefault(); entry.open ? showIndex() : open(entry); });
      listen(entry, 'toggle', () => {
        if (printing) return;
        if (entry.open) entries.forEach(other => { if (other !== entry) other.open = false; });
        sync();
      });
    });
    root.querySelectorAll('[data-story-index],[data-open-chapter]').forEach(link => {
      listen(link, 'click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        if (link.hasAttribute('data-story-index')) showIndex();
        else { const entry = entries.find(item => item.dataset.chapter === link.dataset.openChapter); if (entry) open(entry); }
      });
    });
    function restore() {
      let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      if (!id) { setEntry(null); return; }
      const target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      const entry = target.closest('.sxst-chapter-entry');
      setEntry(entry);
      positionAt(target, entry && target === entry ? entry.querySelector('summary') : null);
    }
    listen(window, 'popstate', restore);
    listen(window, 'hashchange', restore);
    listen(window, 'beforeprint', () => { printing = true; printState = entries.map(e => e.open); entries.forEach(e => { e.open = true; }); });
    listen(window, 'afterprint', () => { entries.forEach((e, i) => { e.open = printState[i]; }); sync(); requestAnimationFrame(() => { printing = false; }); });
    listen(document, 'shopify:section:unload', event => { if (event.target.contains(root)) controller.abort(); });
    root.style.setProperty('--sxst-header-offset', offset() + 'px');
    sync();
    restore();
  }
  document.querySelectorAll('[data-silxine-story]').forEach(mountStory);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-silxine-story]').forEach(mountStory));
})();

  } catch(e) { console.error(e); }
})();
})();
